import type { IS3File } from '../photo-uploader/types';
import { fetchy } from '@bridebook/toolbox/src/fetchy';

export const constructPublicR2Url = (s3response: IS3File, bucket = 'media'): string | null => {
  const r2PublicDomain = `https://${bucket}.bridebook.com`;
  const r2Key = (s3response as any).key;

  if (!r2PublicDomain || !r2Key) {
    console.warn('Missing r2PublicDomain prop or R2 key, falling back to signed URL');
    return (s3response as any).signedUrl || null;
  }

  const publicUrl = `${r2PublicDomain.replace(/\/$/, '')}/${r2Key}`;
  console.log('🔗 Constructed public R2 URL:', publicUrl);
  return publicUrl;
};

export const uploadToCloudflareImagesFromUrl = (
  s3file: IS3File,
  bucket = 'media',
  originalFile?: File,
) => {
  const r2Url = constructPublicR2Url(s3file, bucket);

  if (!r2Url) {
    throw new Error('⚠️ No R2 URL available for Cloudflare Images upload');
  }

  const customId = (s3file as any).key; // Use R2 key as custom ID

  return fetchy().get('/api/cf-images/upload-from-url', {
    imageUrl: r2Url,
    customId: customId || '',
    originalFilename: originalFile?.name || '',
    fileSize: originalFile?.size?.toString() || '',
    fileType: originalFile?.type || '',
    r2Url,
    source: 'file-uploader-url',
  });
};
